export class Immagine {
    public id: number;
    public filename: string;
    public width: number;
    public height: number;
}